/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 NevWare21 Solutions LLC
 * Licensed under the MIT license.
 */
import { REJECTED } from "./constants";
/**
 * @ignore -- Don't include in the generated documentation
 * @internal
 */
export var STRING_STATES = /*#__PURE__*/ [
    "pending", "resolving", "resolved", REJECTED
];
//# sourceMappingURL=state.js.map